export class ShareService {
    static copyToClipboard(text) {
      return navigator.clipboard.writeText(text)
    }
  
    static shareViaWhatsApp(referralCode) {
      try {
        const websiteUrl = import.meta.env.VITE_WEBSITE_URL || window.location.origin
        const referralUrl = `${websiteUrl}/register?referral=${referralCode}`
        const shareMessage = `Hey! Use my referral code ${referralCode} to sign up and get rewards! Join me on ${referralUrl}`
        
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`
        window.open(whatsappUrl, '_blank')
      } catch (error) {
        throw new Error('Error sharing referral code')
      }
    }
  
    static getInitials(firstName, lastName) {
      return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase()
    }
  }